import { render, staticRenderFns } from "./TaxConfig.vue?vue&type=template&id=8f289ba8&scoped=true"
import script from "./TaxConfig.vue?vue&type=script&lang=js"
export * from "./TaxConfig.vue?vue&type=script&lang=js"
import style0 from "./TaxConfig.vue?vue&type=style&index=0&id=8f289ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f289ba8",
  null
  
)

export default component.exports